<modal-header [title]="'Still with us?'" (closeModalFromHeader)="close()"></modal-header>
<mat-dialog-content class="container">
    <div class="auto-logout">Auto logout in</div>
    <div class="countdown">:{{ countdown() }}</div>
    <div>Want to continue your session? Click, "Continue". Or click "Close" to end.</div>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
    <button mat-flat-button class="button-flat-primary" (click)="extendTime()">
        Continue
    </button>
    <button class="button-flat-neutral" mat-flat-button (click)="close()">Close</button>
</mat-dialog-actions>